import { API_ROOT } from "./apiConfig";

const parseApiResponse = async (response) => {
  const payload = await response.json();

  if (!response.ok || !payload?.success) {
    throw new Error(payload?.message || "Request failed");
  }

  return payload;
};

export const fetchHomeAntiBubbleSettings = async () => {
  const response = await fetch(`${API_ROOT}/home/anti-bubble-settings`);
  const payload = await parseApiResponse(response);
  return payload.data || null;
};

export const fetchAdminHomeAntiBubbleSettings = async (token) => {
  const response = await fetch(`${API_ROOT}/admin/home/anti-bubble-settings`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  const payload = await parseApiResponse(response);
  return payload.data || null;
};

export const updateAdminHomeAntiBubbleSettings = async (token, settings) => {
  const response = await fetch(`${API_ROOT}/admin/home/anti-bubble-settings`, {
    method: "PUT",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(settings),
  });

  const payload = await parseApiResponse(response);
  return payload.data || null;
};
